<template>
  <vl-map data-projection="EPSG:4326" style="height: 100%">
    <vl-view :zoom.sync="zoom" :center.sync="center" :rotation.sync="rotation"></vl-view>

    <vl-layer-tile>
      <vl-source-osm></vl-source-osm>
    </vl-layer-tile>

    <vl-feature id="position-feature">
      <vl-geom-multi-point :coordinates="positionData"></vl-geom-multi-point>
      <vl-style-box>
        <vl-style-icon :src="img" :scale="0.4" :anchor="[0.5, 1]"></vl-style-icon>
      </vl-style-box>
    </vl-feature>
    <!-- <vl-overlay @update:position='position = center' id="overlay" :position="center">
      <template slot-scope="scope">
        <div class="overlay-content">
          Hello world!<br>
          Position: {{ center }}
        </div>
      </template>
    </vl-overlay> -->
  </vl-map>
</template>

<script>
import {getAddress} from '@/api/userMG'
export default {
  data () {
    return {
      loginUser: JSON.parse(localStorage.getItem('userdata'))._source.authority,
      zoom: 6,
      center: [50,50],
      rotation: 0,
      selectedFeatures: [],
      drawType: undefined,
      position: [50,50],
      positionData: [[0,0]],
      img: require('../assets/img/position.png')
    }
  },
  /**
   * 创建完毕
   */
  created() {
    this.getAddressData()
  },
  mounted(){},
  methods: {
    getAddressData(){
      var authority = JSON.parse(localStorage.getItem('userdata'))._source.authority
      var obj={}
      if(authority !== 'Super administrator'){
        obj = {
          belonging : JSON.parse(localStorage.getItem('userdata'))._source.belonging
        }
      }
      getAddress(obj)
        .then(res => {
          if(res.code === 201){
            console.log(res);
            this.center = res.center;
            this.position = res.position;
            this.positionData = res.positionData;
            console.log(this.center);
            console.log(this.position);
            console.log(this.positionData);
          }
        })
        .catch(err => {})
    }
  }
}
</script>

<style lang="scss" scoped>
  .feature-popup {
    position: absolute;
    left: -50px;
    bottom: 12px;
    width: 20em;
    max-width: none;
    &:after, &:before {
      top: 100%;
      border: solid transparent;
      content: ' ';
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
    }
    &:after {
      border-top-color: white;
      border-width: 10px;
      left: 48px;
      margin-left: -10px;
    }
    &:before {
      border-top-color: #cccccc;
      border-width: 11px;
      left: 48px;
      margin-left: -11px;
    }
    .card-content {
      max-height: 20em;
      overflow: auto;
    }
    .content {
      word-break: break-all;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Map.vue